import { trackError } from 'helpers/track_error';
import type { CompanyLead } from 'packages/signup/components/signupForm/types';

export default function trackFormSubmitClickedWithPii(
  companyLead: CompanyLead,
  validationSuccess?: boolean
) {
  try {
    GustoAnalytics.trackPii({
      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
      eventName: 'FormSubmitClickedWithPii',
      data: {
        ...companyLead,
        validation_success: validationSuccess,
      },
    });
    GustoAnalytics.track({
      eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
      eventName: 'SignupFormSubmitAttempt',
      data: {
        validation_success: validationSuccess,
      },
    });
  } catch (e) {
    trackError({
      error: new Error('Error tracking FormSubmitClickedWithPii'),
    });
  }
}
